module.exports = __webpack_public_path__ + "img/fd-zh-003.ba2ae391.png";